export enum NycbsPharmaOrderKeys {
  ActiveInsurance = "active_insurance",
  Identifier = "identifier",
  DrugName = "drug_name",
  DrugNameOncoEmr = "drug_name_onco_emr",
  PrimaryDiagnoses = "primary_diagnoses",
  PrimaryDiagnosesDescription = "primary_diagnoses_description",
  SecondaryDiagnoses = "secondary_diagnoses",
  SecondaryDiagnosesDescription = "secondary_diagnoses_description",
  PatientInsuranceState = "patient_insurance_state",
  PlanName = "plan_name",
  PatientRxBin = "patient_rx_bin",
  SftpRxBin = "sftp_rx_bin",
  PatientRxGroup = "patient_rx_group",
  PatientRxPcn = "patient_rx_pcn",
  PatientMemberId = "patient_member_id",
  FormName = "form_name",
  PatientFirstName = "patient_first_name",
  PatientLastName = "patient_last_name",
  PatientDob = "patient_dob",
  PatientGender = "patient_gender",
  PatientAddress = "patient_address",
  PatientPhoneNumber = "patient_phone_number",
  DrugQuantity = "drug_quantity",
  DrugQuantityQualifier = "drug_quantity_qualifier",
  DrugDaysSupply = "drug_days_supply",
  ProviderNpi = "provider_npi",
  ProviderFirstName = "provider_first_name",
  ProviderLastName = "provider_last_name",
  ProviderAddress = "provider_address",
  ProviderPhone = "provider_phone",
  ProviderFax = "provider_fax",
  ReviewType = "review_type",
  CreatedAt = "created_at",
  CmmResultKey = "cmm_result_key",
  PatientMrn = "patient_mrn",
  AssigneeId = "assignee_id",
  CmmStatus = "cmm_status",
  MedicationDrugName = "medication_drug_name",
  Reason = "reason",
  CmmComments = "cmm_comments",
  PaFormOptions = "pa_form_option",
  ErrorText = "error_text",
  FormNameInside = "form_name_inside",
  IsFormDirty = "is_form_dirty",
  PatientEligibilityCheckStatus = "patient_eligibility_check_status",
  IsDiagnosisCodeAvailableOnForm = "is_diagnosis_code_available_on_form",
  IsSecondaryDiagnosisCodeAvailableOnForm = "is_secondary_diagnosis_code_available_on_form",
  DrugFetchedFrom = "drug_fetched_from",
  PortalUsername = "portal_username",
  FormPickedFlag = "form_picked_flag",
  DrugConfidenceScore = "drug_confidence_score",
  DrugPickedThinking = "drug_picked_thinking",
  DiagnosisDetails = "diagnosis_details",
  Type = "type",
  PrimaryDiagnosesData = "primary_diagnoses_data",
  SecondaryDiagnosesData = "secondary_diagnoses_data",
  PrescriptionData = "prescription_data",
  PortalName = "portal_name",
  Metadata = "metadata",
  ExternalSourceIdentifier = "external_source_identifier",
  NdcNumber = "ndc_number",
  NeedsReview = "needs_review",
  ReviewReason = "review_reason",
  Sequence = "seq",
  DrugCohort = "drug_cohort",
  DrugClass = "drug_class",
  GenericName = "generic_name",
  BrandName = "brand_name",
  IsSubstitutionAllowed = "is_substitution_allowed",
  MedicationDecisionResult = "medication_decision_result",
  FailedValidationFields = "failed_validation_fields",
}

export enum PaginationKeys {
  PageNumber = "page_number",
  PageSize = "page_size",
  TotalCount = "total_count",
  TotalPages = "total_pages",
  NextPageNumber = "next_page_number",
  IsNextPageAvailable = "is_next_page_available",
}

export enum NycbsPharmaOrderRequiredKeys {
  DrugName = "drug_name",
  PrimaryDiagnoses = "primary_diagnoses",
  PatientInsuranceState = "patient_insurance_state",
  FormName = "form_name",
  PatientFirstName = "patient_first_name",
  PatientLastName = "patient_last_name",
  PatientDob = "patient_dob",
  PatientGender = "patient_gender",
  PatientAddress = "patient_address_street1",
  DrugQuantity = "drug_quantity",
  DrugQuantityQualifier = "drug_quantity_qualifier",
  DrugDaysSupply = "drug_days_supply",
  ProviderNpi = "provider_npi",
  ProviderFirstName = "provider_first_name",
  ProviderLastName = "provider_last_name",
  ProviderAddress = "provider_address_street1",
  ProviderPhone = "provider_phone",
  ProviderFax = "provider_fax",
  PatientMrn = "patient_mrn",
  PatientMemberId = "patient_member_id",
  PatientAddressCity = "patient_address_city",
  PatientAddressState = "patient_address_state",
  PatientAddressZip = "patient_address_zip",
  ProviderAddressCity = "provider_address_city",
  ProviderAddressState = "provider_address_state",
  ProviderAddressZip = "provider_address_zip",
}

export enum NycbsPharmaOrderRequiredKeysLabelForUI {
  DrugName = "Drug Name",
  PrimaryDiagnoses = "Primary Diagnoses",
  PatientInsuranceState = "Patient Insurance State",
  PlanName = "Plan Name",
  PatientRxBin = "Patient Rx Bin",
  PatientRxGroup = "Patient Rx Group",
  PatientRxPcn = "Patient Rx PCN",
  PatientMemberId = "Patient Member ID",
  FormName = "Form Name",
  PatientFirstName = "Patient First Name",
  PatientLastName = "Patient Last Name",
  PatientDob = "Patient DOB",
  PatientGender = "Patient Gender",
  PatientAddress = "Patient Address",
  DrugQuantity = "Drug Quantity",
  DrugQuantityQualifier = "Drug Quantity Qualifier",
  DrugDaysSupply = "Drug Days Supply",
  ProviderNpi = "Provider NPI",
  ProviderFirstName = "Provider First Name",
  ProviderLastName = "Provider Last Name",
  ProviderAddress = "Provider Address",
  ProviderPhone = "Provider Phone",
  ProviderFax = "Provider Fax",
  PatientMrn = "Patient MRN",
  PatientAddressCity = "Patient Address City",
  PatientAddressState = "Patient Address State",
  PatientAddressZip = "Patient Address Zip",
  ProviderAddressCity = "Provider Address City",
  ProviderAddressState = "Provider Address State",
  ProviderAddressZip = "Provider Address Zip",
}
